document.addEventListener("DOMContentLoaded", function () {
  const integrationsLeft = document.querySelector(".block__case-study-integrations-left");
  const integrationsCenter = document.querySelector(".block__case-study-integrations-center");
  const integrationsRight = document.querySelector(".block__case-study-integrations-right");

  function createAutoSmoothSwiper(container, reverseDirection = false) { // Added reverseDirection parameter
    if (!container) {
      console.warn("Swiper container not found for:", container);
      return null;
    }

    return new Swiper(container, {
      direction: "vertical",
      slidesPerView: "auto",
      spaceBetween: 10,
      freeMode: true,
      grabCursor: false,
      mousewheel: false,
      loop: true,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: reverseDirection, // Apply the reverseDirection parameter here
      },
      speed: 7000,
      breakpoints: {
        1400: {
          spaceBetween: 30,
        },
        1200: {
          spaceBetween: 20,
        },
        768: {
          spaceBetween: 15,
        },
      },
    });
  }

  if (integrationsLeft) {
    createAutoSmoothSwiper(integrationsLeft, true); // Pass true to reverse left slider
  }

  if (integrationsCenter) {
    createAutoSmoothSwiper(integrationsCenter); // Default (false) for center slider
  }

  if (integrationsRight) {
    createAutoSmoothSwiper(integrationsRight, true); // Pass true to reverse right slider
  }
});